/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';

import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Radio, Button, Box, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';

import services from '../Services'


var screenCode = "CROPFORECASTVIEW"

export default function ViewCropForecasting(props) {

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [dateList, setDateList] = useState([]);
    const [cropForcaste, setCropForcaste] = useState([]);


    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: 0,
        cropCategoryID: 0,
        cropID: 0,
 
        isActive: true
    });

    const productcatogerySearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.number().notRequired(),
        cropCategoryID: Yup.number().notRequired(),
        cropID: Yup.number().notRequired(),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            cropCategoryID: formData.cropCategoryID,
            cropID: formData.cropID,
            isActive: formData.isActive
        },
        validationSchema: productcatogerySearchSchema,
        onSubmit: (values) => {
          isActive == true ? trackPromise(GetCropForecastByOperationEntityID(values.operationEntityID)): null
          isActive == false ? trackPromise(GetCropForecastByCropID(values.cropID)): null
        
 
        },
    });

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'CROPFORECASTVIEW');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }
       
    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(GetProductCategoties());
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        trackPromise(GetProductDetails());
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    
    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            setProductcatogery(res);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductDetails(formik.values.cropCategoryID)
        if (res != null) {
            setProduct(res);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            setFactory(res);
        }
    }

    
    async function GetCropForecastByOperationEntityID() {
        var res = await services.GetCropForecastByOperationEntityID(formik.values.operationEntityID);
        res.forEach(x=>{
            x.productListSet.forEach(y=>{
                y.cropForecastDate = y.cropForecastDate.split("T")[0]
            });
           
        });

        if (res != null) {
        
        var now = new Date();
        var now1 = now.setDate(now.getDate() + 6);
        var daysOfYear = [];
        for (var d = new Date(); d <= now1; d.setDate(d.getDate() + 1)) {
            daysOfYear.push(new Date(d));
        }

        var array = [];
        daysOfYear.forEach(x => {
            const date1 = new Date(x);
            const date2 = x.toISOString().split("T")[0]
            var newformattedDate = date1.getUTCDate();
            array.push(
                { id: date2 }
            )
        });
        setDateList(array);
        setCropForcaste(res);
        }
    }

    async function GetCropForecastByCropID() {
        var res = await services.GetCropForecastByCropID(formik.values.cropID)
        res.forEach(x=>{
            x.productListSet.forEach(y=>{
                y.cropForecastDate = y.cropForecastDate.split("T")[0]
            });
           
        });

        if (res != null) {
        var now = new Date();
        var now1 = now.setDate(now.getDate() + 6);
        var daysOfYear = [];
        for (var d = new Date(); d <= now1; d.setDate(d.getDate() + 1)) {
            daysOfYear.push(new Date(d));
        }

        var array = [];
        daysOfYear.forEach(x => {
            const date1 = new Date(x);
            const date2 = x.toISOString().split("T")[0]
            var newformattedDate = date1.getUTCDate();
            array.push(
                { id: date2 }
            )
        });
        setDateList(array);
        setCropForcaste(res);
        }
    }

    const handleRadioChange = (event) => {
        setIsActive(event.target.value);
        setValues({
            ...values,
            operationEntityID: 0,
            cropCategoryID: 0,
            cropID: 0,
        })
        setCropForcaste([]);
    };

    function clearAll() {
        setCropForcaste([]);
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Crop Forecast View|  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/cropForecastView"}
                        btname="Add"
                        pageName="View Crop Forecast"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={2}>
                                 <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}> 
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        style={{ width: '375px' }}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                              
                                    <FormControlLabel
                                        style={{ width: '190px' }}
                                        control={
                                            <Radio
                                                color="secondary"
                                                checked={isActive == 1}
                                                onChange={handleRadioChange}
                                                value={1}
                                                name="radio-button-demo"
                                                inputProps={{ 'aria-label': 'true' }}
                                            />}
                                        label="VCC wise"
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        style={{ width: '180px' }}
                                        control={
                                            <Radio
                                                color="secondary"
                                                checked={isActive == 0}
                                                onChange={handleRadioChange}
                                                value={0}
                                                name="radio-button-demo"
                                                inputProps={{ 'aria-label': 'false' }}
                                            />}
                                        label="SKU wise"
                                        labelPlacement="end"
                                    />
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        {isActive == true ?
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Operation Entity "
                                            value={formik.values.operationEntityID}
                                            onChange={formik.operationEntityID}
                                            style={{ width: '375px' }}
                                            {...getFieldProps('operationEntityID')}
                                        >
                                            <MenuItem key={0} value={0}> Select Operation Entity</MenuItem>
                                            {factory.map((option) => (
                                                option.isActive == true ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                    {option.factoryName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField> : null}
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        {isActive == false ?
                                        <TextField
                                            select
                                            fullWidth
                                            style={{ width: '375px' }}
                                            size="small"
                                            label="Crop Category "
                                            value={formik.values.cropCategoryID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('cropCategoryID')}
                                        >
                                            <MenuItem key={0} value={0}> Select Crop Category</MenuItem>
                                            {productcatogery.map((option) => (
                                                option.isActive == true ? <MenuItem key={option.productCategoryID} value={option.productCategoryID}>
                                                    {option.productCategoryName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField> : null}
                                        {isActive == false ?
                                        <TextField
                                            select
                                            fullWidth
                                            style={{ width: '375px' }}
                                            size="small"
                                            label="Crop "
                                            value={formik.values.cropID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('cropID')}
                                        >
                                            <MenuItem key={0} value={0}> Select Crop</MenuItem>
                                            {product.map((option) => (
                                                <MenuItem key={option.productID} value={option.productID}>
                                                    {option.productName}
                                                </MenuItem>
                                            ))}
                                        </TextField> : null}
                                    </Stack>
                                        <Grid item md={8} xs={12}>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    color='error'
                                                    onClick={() => clearAll()}
                                                > Clear</Button>
                                                <Button
                                                    type="submit"
                                                    color='secondary'
                                                    variant="outlined"
                                                >Search</Button>
                                            </Stack>
                                        </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {cropForcaste.length != 0 ? <>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <TableContainer >
                                <Table size="small" border='1px' aria-label="spanning table">
                                    <TableHead>
                                        <TableRow sx={{ border: "2px solid black", backgroundColor: "#8593AD", fontWeight: "900" }} >
                                            <TableCell align='center' colSpan={2} sx={{ fontWeight: "bold" }} >{name}</TableCell>
                                            {dateList.map((item) => (
                                                <TableCell> {item.id}</TableCell>
                                            ))}
                                        </TableRow>
                                        <TableRow sx={{ border: "2px solid black", backgroundColor: "#D1D9E6" }} >
                                            <TableCell sx={{ fontWeight: "bold" }}>{isActive == true ? 'VCC Name' : 'Crop Name'}</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }}>{isActive == true ? 'Crop Name' : 'VCC Name'}</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align='center'>aaty(Kg)</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {cropForcaste.map((row) => (
                                            <TableRow >
                                                <TableCell>
                                                    {isActive == true ? row.factoryName : row.productName}
                                                </TableCell>
                                                <TableCell>
                                                    {isActive == true ? row.productName : row.factoryName}
                                                </TableCell>
                                               {dateList.map((data)=> {
                                                const value = row.productListSet.find(x=> x.cropForecastDate == data.id)
                                                return (
                                                    <TableCell>{value == undefined ? "-" : value.quantity > 0 ? parseFloat(value.quantity).toFixed(2): "-"}</TableCell>
                                                    );
                                                }
                                               )}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Stack>
                        <br />
                        
                     
                    </>
                        : null}
                </Container>
            </Page>
        </>
    );
}